import { handleTrack } from '../../../utils/tracker';

export const Banner = (): JSX.Element => {
  return (
    <div className="bg-black">
      <a
        href={`/filing/?utm_ref=big-filing-days`}
        onClick={(e) => {
          handleTrack({
            label: 'big-filing-day-page',
            url: `/filing/`,
            obj: e.target,
          });
        }}
      >
        <div className="max-w-screen-xl mx-auto mt-2 relative">
          <img
            className="block sm:hidden"
            id="top-banner"
            alt={'banner-desktop'}
            src={
              'https://assets.clear.in/cleartax/images/1689181917_149314.png'
            }
          />
          <img
            alt={'banner-mobile'}
            id={'top-banner-mobile'}
            src={
              'https://assets.clear.in/cleartax/images/1689181972_androidsmall19.png'
            }
            className="w-full hidden sm:block"
          />
        </div>
      </a>
    </div>
  );
};
